module.exports = __webpack_public_path__ + "img/doc-stack_fill.be4f396c.svg";